<template>
    <b-modal scrollable b-modal :title="title" ref="mdlProrogaEdit" id="mdlProrogaEdit" size="md" @ok="onSalva" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Inizio Permanenza:</label>
                    <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizioPermanenza" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Fine Permanenza:</label>
                    <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFinePermanenza" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Giorni di Proroga</label>
                    <b-form-input v-model="jsonData.numeroGiorni" type="number"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Motivazione</label>
                    <b-form-textarea v-model="jsonData.note" no-resize rows="8"></b-form-textarea>
                </b-col>
            </b-row>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: { DatePicker, ModalError },
    data() {
        return {
            listKey: 0,
            pathResource: "/cotrichiesteproroga",
            id: null,
            idPropostaAccesso: null,
            title: "",
            jsonData: { idCot: "", note: "", numeroGiorni: null, dataInizioPermanenza: "" },
        };
    },
    watch: {},
    methods: {
        init(id, idPropostaAccesso) {
            let me = this;
            me.id = id;
            me.idPropostaAccesso = idPropostaAccesso;
            if (id === null) {
                me.title = "Nuova Proroga";
                me.jsonData = { idCot: idPropostaAccesso, note: "", numeroGiorni: "", dataInizioPermanenza: "" };
            } else {
                me.title = "Modifica Proroga";
                me.loadData();
            }
            me.$refs.mdlProrogaEdit.show();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(link, null, me.resultResponse, me.resutlError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.listKey++;
        },
        resutlError(error) {
            console.log(error);
        },
        close() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlProrogaEdit.hide();
        },
        onSalva(bvModalEvent) {
            let me = this;
            me.jsonData.idAccettazione = me.idAccettazione;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultResponseSave, me.resultErrorSave);
            bvModalEvent.preventDefault();
        },
        resultResponseSave() {
            let me = this;
            me.$refs.mdlProrogaEdit.hide();
            me.$emit("saveSuccess");
        },
        resultErrorSave(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
